import React, { useState, useEffect } from "react";

const CalendaryPopup = () => {
  useEffect(() => {
    const head = document.querySelector("head");
    const script = document.createElement("script");

    script.setAttribute(
      "src",
      "https://assets.calendly.com/assets/external/widget.js"
    );
    script.setAttribute("type", "text/javascript");
    script.setAttribute("async", "");

    head.appendChild(script);
  }, []);

  return (
    <div
      className="calendly-inline-widget"
      data-url="https://calendly.com/idan-illustria/demo?hide_landing_page_details=1&primary_color=f26800&embed_type=PopupWidget&embed_domain=1&back=0"
      style={{
        zIndex: 200,
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(31, 31, 31, 0.4)",
      }}
    />
  );
};
export default CalendaryPopup;
